import { ModuleCodeGuard } from '@/api/operations/guards/module-operation-guard.model'
import { StoreUtils } from '@/shared/util/store-utils'

export class ModuleOperationGuard {
    static get canAccessBilling(): boolean {
        const activeModule = StoreUtils.selectedLaboratoryConfiguration?.activeModules.find(
            module => module.moduleCode === ModuleCodeGuard.BILLING_CODE)
        return !!activeModule?.activeStatus
    }

    static get canAccessRequests(): boolean {
        const activeModule = StoreUtils.selectedLaboratoryConfiguration?.activeModules.find(
            module => module.moduleCode === ModuleCodeGuard.REQUESTS_CODE)
        return !!activeModule?.activeStatus
    }
}
